import React, { useState } from "react";
import { Form } from "react-final-form";
import { UiExtensionPadProps } from "../../models/components/extensionpad.model";
import UiButton from "../button/Button";
import UiInputText from "../input-text/InputText.component";

const UiExtensionPad = (props: UiExtensionPadProps) => {
	/**
	 * Keypad
	 */
	const keypadKeys: { [x: string]: { value: string; subValue?: string }[] } = {
		row1: [
			{ value: "1", subValue: "-" },
			{ value: "2", subValue: "ABC" },
			{ value: "3", subValue: "DEF" },
		],
		row2: [
			{ value: "4", subValue: "GHI" },
			{ value: "5", subValue: "JKL" },
			{ value: "6", subValue: "MNO" },
		],
		row3: [
			{ value: "7", subValue: "PQRS" },
			{ value: "8", subValue: "TUV" },
			{ value: "9", subValue: "WXYZ" },
		],
		row4: [{ value: "*" }, { value: "0", subValue: "+" }, { value: "#" }],
	};
	const setKeypadKeyTemplate = (
		key: string,
		keyRow: { value: string; subValue?: string }[]
	): React.ReactNode => {
		return (
			<div
				key={key}
				className="dialkey-row"
			>
				{keyRow.map((key) => (
					<div
						className="key-item"
						key={key.value}
						onClick={() => handleKeypadInput(key.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								handleKeypadInput(key.value);
							}
						}}
						role="button"
						tabIndex={0}
					>
						<span className="key-value">{key.value}</span>
						{key.subValue && <span className="key-subvalue">{key.subValue}</span>}
					</div>
				))}
			</div>
		);
	};
	const setKeypadRowTemplate = (): React.ReactNode[] => {
		const rows: React.ReactNode[] = [];
		Object.entries(keypadKeys).forEach(([key, val]) => {
			const row: React.ReactNode = setKeypadKeyTemplate(key, val);
			rows.push(row);
		});
		return rows;
	};

	/**
	 * Extension
	 */
	const [formData, setFormData] = useState<{ extension: string }>({ extension: "" });
	const handleKeypadInput = (value: string) => {
		setFormData({ extension: formData.extension + value });
	};

	const handleInputChange = (value: string) => {
		setFormData({ extension: value });
	};
	const sendExtension = (): void => props.sendExtension(formData.extension);

	return (
		<div className="k-extensionpad">
			{/* Keyboard input */}
			<Form
				onSubmit={sendExtension}
				initialValues={formData}
				render={({ handleSubmit }) => (
					<form onSubmit={handleSubmit}>
						<div className="input-container">
							{/* Extension number (input) */}
							<UiInputText
								id="extension"
								onChange={(e) => handleInputChange(e.target.value)}
								label="UI_COMPONENTS.EXTENSIONPAD.LABEL"
								name="extension"
							></UiInputText>

							<UiButton
								type="submit"
								className="p-button-rounded"
								icon="pi pi-send"
								onClick={sendExtension}
							></UiButton>
						</div>
					</form>
				)}
			/>

			{/* Extensionpad input */}
			<div>{setKeypadRowTemplate()}</div>
		</div>
	);
};
export default UiExtensionPad;
